import {useEffect, useState} from 'react';
import {setAppData, setSession, setToken} from '../redux/appSlice';
import {setUserView} from '../redux/userSlice';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {userApi} from '../redux/userApi';
/*role_id - bigint - іден доступу(1-admin,2-user,3-ware,4-subware,5-terminate)

role_id=1   admin
role_id=2   user
role_id=3   Склад
role_id=4   Продавець(склад с урезанным функционалом)
role_id передается при авторизации(clients/auth)
//164.92.154.20
        //46.101.108.64
*/
const useGetSession = () => {
	const dispatch: any = useDispatch();
	const {i18n} = useTranslation();
	const [isLoaded, setIsLoaded] = useState(false);
	const [loadType, setLoadType] = useState<'error' | 'synced' | 'noStructure'>(
		'noStructure',
	);
	const [loadText, setLoadText] = useState('loading...');

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Получаем токен авторизации
				const startResult = await dispatch(
					userApi.endpoints.getStart.initiate(),
				).unwrap();

				// Устанавливаем токен в зависимости от типа логина
				const loginType = process.env.REACT_APP_LOGIN as 'login' | 'laraLogin';
				if (loginType === 'login') {
					dispatch(setToken(startResult.token || null));
				} else if (loginType === 'laraLogin') {
					dispatch(setToken(startResult.api_token || null));
				}

				const response = await fetch(
					process.env.REACT_APP_BASE_LARA_URL ||
						'https://46.101.108.64/api/account',
					{
						method: 'POST',
						body: JSON.stringify({lang: 'en-gb'}),
					},
				);
				const data = await response.json();
				if (data?.user_data && data.user_data.length !== 0) {
					dispatch(setAppData(data));
					dispatch(setSession(data));
					dispatch(setUserView(data?.user_data));
					setIsLoaded(true);
				} else {
					setLoadType('error');
					setLoadText('User not found');
				}
			} catch (err: any) {
				console.log(err.message);
			}
		};
		fetchData();
	}, [dispatch, i18n.language]);
	return {isLoaded, loadType, loadText};
};

export default useGetSession;
